import { Heading, Text, VStack } from '@chakra-ui/react'
import { Strata } from './Strata'

export const WhatIsThisSection = () => (
  <Strata tone="band" contentProps={{ textAlign: 'center' }}>
    <Heading size="lg" mb={6}>
      What is a sacrifice?
    </Heading>
    <VStack spacing={4} align="start" textAlign="left">
      <Text color="text.body">
        A sacrifice is a public, onchain token transfer that earns you points in a campaign. Every
        transaction is permanently recorded on the blockchain — anyone can verify it.
      </Text>
      <Text color="text.body">
        You send tokens directly from your own wallet to the campaign address. No custodian holds
        your funds; the transfer settles itself, onchain, without intermediaries.
      </Text>
      <Text color="text.body">
        Points are calculated in real time based on the USD value you send and the time-decay rate
        at the moment of your sacrifice. Early sacrificers earn more points per dollar.
      </Text>
    </VStack>
  </Strata>
)

export default WhatIsThisSection
